/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from 'react';
import styles from './LanguageSelector.module.scss';
import classnames from 'classnames';
import ArrowDown from 'app/assets/Icons/ArrowDown.svg';
import { LoadingSpinner } from '../LoadingSpinner';
import { Language } from './LanguageSelector.interface';

interface LanguageSelectorProps {
  languages: Language[];
  selectedLanguage: string;
  handleOnLanguageSelectorChange: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  placement?: 'left' | 'right';
  isLoading?: boolean;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  languages,
  selectedLanguage,
  handleOnLanguageSelectorChange,
  placement,
  isLoading
}) => {
  const [searchLanguage, setSearchLanguage] = useState<string>('');
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredLanguages = languages.filter((language) =>
    language?.name?.toLowerCase().includes(searchLanguage?.toLowerCase())
  );

  return (
    <div ref={dropdownRef} className={styles['language-selector']}>
      <div
        className={styles['custom-select']}
        onClick={() => setShowDropdown(!showDropdown)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowDropdown(!showDropdown);
          }
        }}
      >
        <span>{selectedLanguage}</span>
        <div className={styles['toggle-icon']}>
          <img
            src={ArrowDown}
            alt="Arrow Down"
            className={classnames({
              [styles.rotate]: showDropdown
            })}
          />
        </div>
      </div>
      {showDropdown && (
        <div
          className={classnames(styles['dropdown-content'], {
            [styles['left-alignment']]: placement === 'left'
          })}
        >
          <div className={styles['search-language']}>
            {isLoading ? (
              <LoadingSpinner
                containerStyle={{
                  position: 'relative',
                  width: 'auto',
                  height: 'auto',
                  backdropFilter: 'unset',
                  marginBottom: '0.5rem'
                }}
                imageStyle={{ width: '3rem', height: '1.5rem' }}
              />
            ) : null}
            <input
              type="text"
              placeholder="Search Language"
              value={searchLanguage}
              onChange={(e) => setSearchLanguage(e.target.value)}
              className={styles['search-bar']}
            />
          </div>
          <div className={styles.options}>
            {filteredLanguages.map((language) => (
              <div
                key={language.labelName}
                className={styles.option}
                onClick={() => {
                  handleOnLanguageSelectorChange({
                    target: { value: language }
                  } as any);
                  setShowDropdown(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleOnLanguageSelectorChange({
                      target: { value: language }
                    } as any);
                    setShowDropdown(false);
                  }
                }}
              >
                {language.labelName}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
